import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Select } from '../../Select';
const getYearsOptions = (min, length) => Array.from({ length }, (_, index) => ({
    value: min + index,
    label: `${min + index}`,
}));
export const YearSelect = memo(function YearSelect({ date, changeYear, minYear = new Date().getFullYear() - 4, maxYear = new Date().getFullYear() + 4, dataTestId, }) {
    const yearsOptions = useMemo(() => getYearsOptions(minYear, maxYear - minYear + 1), [minYear, maxYear]);
    const value = useMemo(() => ({ label: `${date.getFullYear()}`, value: date.getFullYear() }), [date]);
    const handleChange = useCallbackRef((option) => {
        if (option) {
            changeYear(option.value);
        }
    });
    return (_jsx(Select, { value: value, onChange: handleChange, options: yearsOptions, isClearable: false, dataTestId: dataTestId ? `${dataTestId}-year-select` : undefined }));
});
